/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
 */

import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  CREATE_BENEFICIARY: {
    id: 'beneficiary.CREATE_BENEFICIARY',
    defaultMessage: 'CREATE_BENEFICIARY'
  },
  BENEFICIARY_ACTION_CANCEL: {
    id: 'beneficiary.BENEFICIARY_ACTION_CANCEL',
    defaultMessage: 'BENEFICIARY_ACTION_CANCEL'
  },
  FIRST_NAME_LABEL: {
    id: 'beneficiary.FIRST_NAME_LABEL',
    defaultMessage: 'FIRST_NAME_LABEL'
  },
  LAST_NAME_LABEL: {
    id: 'beneficiary.LAST_NAME_LABEL',
    defaultMessage: 'LAST_NAME_LABEL'
  },
  BIRTH_DATE_LABEL: {
    id: 'beneficiary.BIRTH_DATE_LABEL',
    defaultMessage: 'BIRTH_DATE_LABEL'
  },
  PHONE_NUMBER_LABEL: {
    id: 'beneficiary.PHONE_NUMBER_LABEL',
    defaultMessage: 'PHONE_NUMBER_LABEL'
  },
  EMAIL_LABEL: {
    id: 'beneficiary.EMAIL_LABEL',
    defaultMessage: 'EMAIL_LABEL'
  },
  REMARK_LABEL: {
    id: 'beneficiary.REMARK_LABEL',
    defaultMessage: 'REMARK_LABEL'
  },
  CREATE_BENEFICIARY_LABEL: {
    id: 'beneficiary.CREATE_BENEFICIARY_LABEL',
    defaultMessage: 'CREATE_BENEFICIARY_LABEL'
  },
  DATE_INVALID: {
    id: 'beneficiary.DATE_INVALID',
    defaultMessage: 'DATE_INVALID'
  },
  BENEFICIARY_RECOMMANDED: {
    id: 'beneficiary.BENEFICIARY_RECOMMANDED',
    defaultMessage: 'BENEFICIARY_RECOMMANDED'
  },
  MANDATORY_FIELD: {
    id: 'consumer.MANDATORY_FIELD',
    defaultMessage: 'MANDATORY_FIELD'
  }
})



// WEBPACK FOOTER //
// ./src/constants/Beneficiary.js